import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  src: "/images/logos/logo/android-chrome-192x192.png",
  alt: ""
}

import { ref } from 'vue'
import { useRouter } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'AnimatedLogo',
  props: {
  light: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

const router = useRouter()
const isLoading = ref(false)

router.beforeEach(() => {
  isLoading.value = true
})
router.afterEach(() => {
  setTimeout(() => {
    isLoading.value = false
  }, 200)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", _hoisted_1))
}
}

})